import { c as _c } from "react/compiler-runtime";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelListHeaderPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Button } from "@website/ui/button";
import { Switch } from "@website/ui/switch";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { HotelFilterChips } from "@website/widget/filter";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelListHeader: FC<HotelListHeaderPropertiesType> = properties => {
  const $ = _c(34);
  const router = useRouter();
  const {
    loading,
    totalItem,
    city,
    sortProperties,
    selectedFiltersCount,
    setFilterOpen,
    hasFilter: t0,
    hasCityPrefix: t1,
    children,
    chipsFiltersSchema,
    hasCityNearby
  } = properties;
  const hasFilter = t0 === undefined ? true : t0;
  const hasCityPrefix = t1 === undefined ? true : t1;
  const t2 = selectedFiltersCount ? "secondary" as const : "neutral" as const;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon className="text-sm" name="tune" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== router || $[2] !== selectedFiltersCount) {
    t4 = selectedFiltersCount ? `فیلترها (${numberConvert(selectedFiltersCount, {
      locale: router.locale
    })})` : "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627";
    $[1] = router;
    $[2] = selectedFiltersCount;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== setFilterOpen) {
    t5 = () => setFilterOpen && setFilterOpen(_temp);
    $[4] = setFilterOpen;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      variant: "round-outline" as const,
      color: t2,
      size: "small" as const,
      StartIcon: t3,
      children: t4,
      onClick: t5
    };
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const buttonProperties = t6;
  let t7;
  if ($[10] !== city || $[11] !== hasCityPrefix || $[12] !== loading || $[13] !== totalItem) {
    t7 = <div className="-mt-5 hidden lg:mt-0 lg:block"><HotelCityTitle city={city} hasCityPrefix={hasCityPrefix} loading={loading} totalItem={totalItem} /></div>;
    $[10] = city;
    $[11] = hasCityPrefix;
    $[12] = loading;
    $[13] = totalItem;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== hasCityNearby || $[16] !== router) {
    t8 = hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch key={`nearby=${router.query?.nearby}`} name="nearby" label={"\u0646\u0645\u0627\u06CC\u0634 \u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
      query: deepOmit({
        ...omit(router.query, ["geo_property_summary"]),
        nearby: !router.query?.nearby || undefined
      }, isFilled)
    }, undefined, {
      shallow: true,
      scroll: false
    })} color="secondary" className="!text-body-2 !hidden flex-row-reverse !items-center !p-0 lg:!flex" />;
    $[15] = hasCityNearby;
    $[16] = router;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== buttonProperties || $[19] !== hasFilter) {
    t9 = hasFilter && <div className="xl:hidden"><Button className="!whitespace-nowrap" {...buttonProperties} /></div>;
    $[18] = buttonProperties;
    $[19] = hasFilter;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== sortProperties) {
    t10 = <HotelSortView {...sortProperties} />;
    $[21] = sortProperties;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== chipsFiltersSchema) {
    t11 = chipsFiltersSchema && <HotelFilterChips chipsFiltersSchema={chipsFiltersSchema} classname="block md:hidden" deferRangeUpdates={false} />;
    $[23] = chipsFiltersSchema;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== children || $[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <div className="flex justify-start gap-2">{t8}{t9}{t10}{children}{t11}</div>;
    $[25] = children;
    $[26] = t10;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t7) {
    t13 = <><div className="lg:border-outline-thin bg-on-color-high-emphasis -mx-6 flex flex-wrap items-center justify-between gap-2 overflow-auto border border-b-0 p-3 px-5 lg:m-0 lg:overflow-visible lg:rounded-lg lg:border-b lg:bg-transparent lg:px-3">{t7}{t12}</div></>;
    $[31] = t12;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
function _temp(state) {
  return !state;
}